/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Client } from '@app/clients/clients/client.model';
import { ClientsFormComponent } from '@app/clients/clients/clients-form/clients-form.component';

@Injectable({
  providedIn: 'root',
})
export class ClientsFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open client form
   * @param client Dialog data
   */
  public open(client: null | Client = null) {
    const modal = this.modalService.open(ClientsFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.client = client;
    return modal.result;
  }
}
